import getAPIResponse from "./common/Common";

export async function stopPlayer(key) {
    return await getAPIResponse("/api/v1/user/stop-player", {
        key: key
    }, "post");
}
